<div class="flight-extras-block__wrapper">
	<div class="grid no-padding">

		<div class="col-12 flight-extras-block__details">

			<div class="flight-extras-block__details--logo" [tooltip]='INDRA_printAirlineName()' [attr.aria-label]="'review.extrasBlock.aria.flightOperatedBy'| ibeadmin | async">
				<app-svg [svg]='INDRA_printAirlineLogo()' [alt]='INDRA_printAirlineName()' [classes]="'logo'"></app-svg>
			</div>

			<div class="flight-extras-block__details--description">
				<div class="flight-extras-block__details--description__flight">
					<p tooltip="{{flightDetail.item.departureLocation.city}}"> 
						<b> {{flightDetail.item.departureLocation.city}}</b> {{'review.extrasBlock.text.to' | ibeadmin | async}} <b>{{flightDetail.item.arrivalLocation.city}}</b>
					</p>
				</div>

				<div class="flight-extras-block__details--description__feature">
					<span *ngIf="feature && featureQuantity == 0">
						{{featureName}} {{ 'review.cardOffer.text.' + extraDescription | ibeadmin | async }} {{price}}
					</span>
					<span *ngIf="!feature" class="muted italic">
						{{'review.extrasBlock.text.notAvailable' | ibeadmin | async}}
					</span>

					<span *ngIf="flight && feature && featureQuantity != 0" class="highlighted">
						{{ featureQuantity }}x {{featureName}} {{('review.cardOffer.text.added' | ibeadmin | async).toLowerCase()}}
					</span>
				</div>
			</div>
		</div>

		<div class="col-12 flight-extras-block__buttons">
			<button *ngIf="feature && featureQuantity == 0" 
				(click)="INDRA_handleOpenExtra(feature.action)" 
				class="button button--small button-accent extras-feature__button" 
				[attr.aria-label]="('review.extrasBlock.aria.openDialogTo'| ibeadmin | async) + ' ' + ('review.cardExtras.text.' + (feature.action.label | ibeadmin | async).toLowerCase() | ibeadmin | async)">
				<span>{{ feature.action.label | ibeadmin | async }}</span>
			</button>

			<button *ngIf="feature && feature.action && featureQuantity != 0" (click)="INDRA_handleOpenExtra(feature.action)" 
				class="button button--small button-main-line extras-feature__button" 
				[attr.aria-label]="('review.extrasBlock.aria.openDialogTo'| ibeadmin | async) + ' ' + ('review.cardExtras.text.edit' | ibeadmin | async)">
				<span>{{'review.cardExtras.text.edit' | ibeadmin | async}}</span>
			</button>
		</div>
	</div>

</div>